module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_cpp2_jp.09bb31bfd1d9196f645c830bb00e3182.png";